import React from 'react';
import ConfirmationModal, { BoldText } from '../../ConfirmationModal';
import { CALL_LIST } from '../../../support/cypressTags';

const UpdateModal = ({ isOpen, onCancel, onConfirm, impactedCount, newStatus }) => (
  <ConfirmationModal
    isOpen={isOpen}
    onCancel={onCancel}
    onConfirm={onConfirm}
    title="Status Switch Confirmation"
    confirmCyTag={CALL_LIST.BULK_SWITCH_STATUS_CONFIRMATION}
  >
    Switch <BoldText>{impactedCount}</BoldText> record{impactedCount > 1 ? 's' : ''} to{' '}
    <BoldText>{newStatus}</BoldText> status?
  </ConfirmationModal>
);

export default UpdateModal;
